 <template>
    <div>
        <div v-if="!innerIsReview">
            <v-container class="px-0" fluid v-show="innerShouldShow">
                <validation-provider
                    v-slot="{ errors }"
                    :name="label || 'This'"
                    :rules="rules"
                    v-bind="providerProps"
                    v-show="innerShouldShow"
                    :ref="'validate'+fieldAssignmentId"
                    :vid="'validate-' + fieldAssignmentId"
                >
                    <h3 v-if="directions">{{ directions }}</h3>
                    <div v-if="mode === 'radio'">
                        <div v-if="parentCategories.length">
                            <v-radio-group v-model="selectedParentCategory">
                                <div
                                    v-for="(option, i) in parentCategories"
                                    :class="
                                        selectedParentCategory === option.id
                                            ? 'mb-3 checkbox-new selected'
                                            : 'mb-3 checkbox-new'
                                    "
                                    :key="i"
                                >
                                    <v-radio
                                        v-bind="vProps"
                                        :label="option.name"
                                        :error-messages="errors"
                                        :value="option.id"
                                        @click="toggleCategory(option.id, true)"
                                    ></v-radio>
                                </div>
                            </v-radio-group>
                            <div
                                v-if="
                                    selectedParentCategory && childCategories.length
                                "
                            >
                                <label>Let's get a little bit more specific</label>

                                <div
                                    v-for="(option, i) in childCategories"
                                    :key="i"
                                    :class="
                                        selectedChildCategories.indexOf(option.id) >
                                        -1
                                            ? 'checkbox-new selected'
                                            : 'checkbox-new'
                                    "
                                >
                                    <v-checkbox
                                        v-bind="vProps"
                                        :label="option.name"
                                        :error-messages="errors"
                                        :value="option.id"
                                        v-model="selectedChildCategories"
                                        @click="toggleCategory(option.id)"
                                    ></v-checkbox>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            No Categories Found
                        </div>
                    </div>
                    <div v-else>
                        <v-select
                                v-model="innerValue"
                                v-bind="vProps"
                                :chips="true"
                                :deletable-chips="true"
                                :multiple="true"
                                :error-messages="errors"
                                :items="allCategories"
                                item-value="id"
                                item-text="name"
                        >
                            <template #label>
                                <span v-if="innerLabel" v-html="innerLabel"></span>
                            </template>
                        </v-select>
                    </div>
                </validation-provider>
            </v-container>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue && innerValue.length">
                    <div>{{ displayParentCategory && displayParentCategory.name || '' }}</div>
                    <div
                        v-if="displayChildCategories.length"
                        v-for="category in displayChildCategories"
                    >
                        - {{ category.name }}
                    </div>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin'
import { mapActions, mapState } from 'vuex'
import TypeReview from './TypeReview'

export default {
    name: 'TypeCategories',
    mixins: [formMixin],
    components: {
        TypeReview
    },
    props: {
        mode: {
            type: String,
            required: false
        }
    },
    data: () => {
        return {
            selectedParentCategory: null,
            selectedChildCategories: [],
            allCategories:[]
        }
    },
    methods: {
        ...mapActions('venue', ['getVenueCategories']),
        ...mapActions('product', ['getProductCategories']),
        toggleCategory(value, parent = false) {
            let val = this.innerValue;
            if (parent) {
                val = [];
                this.selectedChildCategories = []
            }
            val.push(value);
            this.innerValue = [...val]; // signal change
        }
    },
    async mounted() {
        if( this.settings?.category_type === 'venue' ) {
            await this.getVenueCategories();
            this.allCategories = this.venueCategories;
        } else if( this.settings?.category_type === 'item' ) {
            await this.getProductCategories();
            this.allCategories = this.productCategories;
        }

        if (!this.innerValue) this.innerValue = [];
        if (this.innerValue.length) {
            let pc = this.allCategories.find(x => this.innerValue.includes(x.id) && !x.parent_id);
            this.selectedParentCategory = pc && pc.id || null;
            this.selectedChildCategories = this.allCategories.filter(x => this.innerValue.includes(x.id) && x.parent_id).map(x => x.id);
        }

        if (this.innerValue.length) {
            this.$nextTick(async () => {
                if( this.$refs['validate' + this.fieldAssignmentId] )
                    await this.$refs['validate' + this.fieldAssignmentId].validate();
            });
        }

        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        ...mapState('venue', ['venueCategories']),
        ...mapState('product', ['productCategories']),
        parentCategories() {
            return this.allCategories.filter(x => !x.parent_id)
        },
        childCategories() {
            return this.allCategories.filter(
                x => x.parent_id === this.selectedParentCategory
            )
        },
        displayParentCategory() {
            return this.venueCategories.find(
                x => x.id === this.selectedParentCategory
            )
        },
        displayChildCategories() {
            return this.venueCategories.filter(
                x => this.selectedChildCategories.indexOf(x.id) > -1
            )
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {}
        }
    }
}
</script>
